<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-user-friends"></i></span>
          Kontaktlista
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group
        label="Rubrik"
        :for="'ceListContactsHeadline' + content.id"
        label-sr-only
      >
        <!-- <b-form-input :value="content.headline" @change="updateHeadline" id="headline" placeholder="Skriv en rubrik..."></b-form-input> -->
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceListContactsHeadline' + content.id"
          placeholder="Rubrik för listan... (valfritt)"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-button @click="selectWindowOpen = true" variant="success" size="sm">
          Lägg till kontakter <i class="fas fa-plus"></i>
        </b-button>
      </b-form-group>
      <b-form-group>
        <!-- <label>Tillagda kontakter</label> -->
        <div class="ce-list">
          <div
            class="ce-list-item"
            v-for="(contact, index) in filteredContacts"
            :key="contact.id"
          >
            <div class="ce-list-item-prefix">
              <!-- Hämta fil-objektet från medialibrary -->
              <b-avatar
                v-if="contact.user_id"
                size="4rem"
                :src="contact.avatar ? contactAvatars[index] : ''"
                badge
                badge-variant="success"
                badge-offset="-2px"
              />
              <b-avatar
                v-else
                size="4rem"
                :src="contact.avatar ? contactAvatars[index] : ''"
              />
            </div>
            <div class="ce-list-item-desc">
              <h6 class="mb-0">{{ contact.first_name }}</h6>
            </div>
            <div class="ce-list-item-action">
              <b-button
                @click="removeContact(contact)"
                variant="flat-primary"
                size="sm"
                ><i class="fas fa-trash"></i
              ></b-button>
            </div>
          </div>
        </div>
      </b-form-group>
    </div>

    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div class="ce-contact-list">
        <!-- For each contact in contact_list... -->
        <b-row
          v-for="(contact, index) in filteredContacts"
          :key="contact.id"
          class="ce-contact-list-item"
        >
          <b-col cols="12" md="6" class="ce-contact-info">
            <div class="ce-contact-avatar">
              <b-avatar
                size="4rem"
                :src="contact.avatar ? contactAvatars[index] : ''"
              />
            </div>
            <div class="ce-contact-description">
              <h6 class="mb-0">
                {{ contact.first_name }} {{ contact.last_name }}
              </h6>
              <p>
                <small
                  ><span v-if="contact.organisation">{{
                    contact.organisation
                  }}</span></small
                >
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6" class="ce-contact-actions mt-1 mt-md-0">
            <span v-if="contact.phone" class="mr-1">
              <a
                :href="'tel:' + contact.phone"
                class="btn btn-outline-primary btn-sm"
                ><i class="fas fa-phone"></i
              ></a>
            </span>
            <span v-if="contact.mobile" class="mr-1">
              <a
                :href="'tel:' + contact.mobile"
                class="btn btn-outline-primary btn-sm"
                ><i class="fas fa-mobile"></i
              ></a>
            </span>
            <span v-if="contact.mobile" class="mr-1">
              <a
                :href="'sms:' + contact.mobile"
                class="btn btn-outline-primary btn-sm"
                ><i class="fas fa-comment-dots"></i
              ></a>
            </span>
            <b-button
              @click="goToContactDetails(contact.id)"
              variant="primary"
              class="ml-auto btn-sm"
              >Visa</b-button
            >
          </b-col>
        </b-row>
      </div>
    </div>

    <b-modal
      id="modal-select-contacts"
      centered
      title="Välj kontakter"
      ok-only
      size="lg"
      v-model="selectWindowOpen"
    >
      <b-card-text>
        <SelectContacts
          @selectedContactsUpdated="updateSelectedContacts($event)"
          :currentContacts="tempContacts"
        />
      </b-card-text>
      <template #modal-footer>
        <b-button variant="success" @click="addContacts">
          Lägg till markerade
        </b-button>
        <b-button variant="secondary" @click="cancelAddingContacts">
          Avbryt
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BFormGroup,
  BFormInput,
  BModal,
  BCardText,
  BRow,
  BCol,
} from "bootstrap-vue";
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import SelectContacts from "@/components/SelectContacts";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import { createNamespacedHelpers, mapGetters } from "vuex";
import axios from "axios";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeListContacts",
  mixins: [ContentElementButtonGroupMixin],
  props: {
    content: {},
    editMode: Boolean,
  },
  data() {
    return {
      tempContacts: [],
      selectWindowOpen: false,
      selectedContactIds: [],
      oldContacts: [],
      contactAvatars: [],
    };
  },
  components: {
    BButton,
    BAvatar,
    CeButtonGroup,
    BFormGroup,
    BFormInput,
    BModal,
    BCardText,
    BRow,
    BCol,
    SelectContacts,
  },
  async mounted() {
    this.tempContacts = this.content.items ?? [];
    for (let i = 0; i < this.filteredContacts.length; i++) {
      if (
        this.filteredContacts[i].avatar &&
        this.filteredContacts[i].avatar.medium
      ) {
        this.$set(
          this.contactAvatars,
          i,
          await this.fetchImageWithToken(this.filteredContacts[i].avatar.medium)
        );
      } else {
        this.$set(this.contactAvatars, i, null);
      }
    }
  },

  watch: {
    filteredContacts: async function () {
      this.contactAvatars = [];
      for (let i = 0; i < this.filteredContacts.length; i++) {
        if (
          this.filteredContacts[i].avatar &&
          this.filteredContacts[i].avatar.medium
        ) {
          this.$set(
            this.contactAvatars,
            i,
            await this.fetchImageWithToken(
              this.filteredContacts[i].avatar.medium
            )
          );
        } else {
          this.$set(this.contactAvatars, i, null);
        }
      }
    },
  },

  computed: {
    ...mapGetters({ contacts: "getContacts" }),
    filteredContacts: function () {
      return this.contacts.filter((ct) => {
        return this.tempContacts.includes(ct.id);
      });
    },
    getContact(id) {
      return this.getContacts().find((ct) => ct.id === id);
    },
  },
  methods: {
    ...mapActions(["updateContent", "uploadContentItems"]),
    updateHeadline(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    async fetchImageWithToken(imageUrl) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        return URL.createObjectURL(response.data);
      } catch (error) {
        return "";
      }
    },
    updateList() {
      let content = this.content;
      content.items = this.selectedContactIds;

      this.tempContacts = content.items ?? [];
      this.uploadContentItems(content);
    },
    updateSelectedContacts: function (contacts) {
      this.oldContacts = contacts.oldContacts;
      this.selectedContactIds = contacts.newContacts;
    },
    addContacts: function () {
      this.selectWindowOpen = false;
      this.oldContacts = this.selectedContactIds;
      this.updateList();
    },
    cancelAddingContacts: function () {
      this.selectWindowOpen = false;
      this.selectedContactIds = this.oldContacts;
      this.updateList();
    },
    removeContact: function (contact) {
      this.selectedContactIds.splice(
        this.tempContacts.findIndex((ctId) => ctId === contact.id),
        1
      );
    },
    goToContactDetails(contactId) {
      this.$router.push({
        name: "contact-details",
        params: { title: "", id: contactId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
  /* min-width: 79px; */
}
.ce-list-item-desc {
  margin-right: auto;
}

.ce-contact-list {
  margin-left: 1rem;
  margin-right: 1rem;
}
.ce-contact-list-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #ebe9f1;
}
.ce-contact-list-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
.ce-contact-info {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
}
.ce-contact-avatar {
  padding-right: 1rem;
}
.ce-contact-actions {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
}
</style>
